import React, { useCallback, useEffect, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import moment from 'moment';
import { isEmpty } from 'lodash-es';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import TimeSlots from './TimeSlots';
import { StyledModal } from './components/StyledModal';
import ConfirmAppointment from './ConfirmAppointment';
import { getNextAvailableSlot } from 'redux/reducer/shift';
import { cleverTapAnl } from 'utilities';
import { EventAppointmentSlotSelect } from 'utilities/clevertapEvent';

interface IProps {
  isOpen: boolean;
  isReschedule?: boolean;
  doctor: any;
  appointment?: any;
  slot?: any;
  onClose: (x?: any) => void;
}

function BookAppointmentModal({
  isOpen,
  isReschedule,
  doctor,
  appointment,
  slot,
  onClose,
  ...props
}: IProps) {

  const { nextAvailableSlotByClinicId } = useSelector(state => state.shift);
  const { closingBookingModal } = useSelector(state => state.appointment);
  const nextSlotDate = nextAvailableSlotByClinicId[doctor.clinicID]?.date;
  const [state, setState] = useState({
    activeClinicID: doctor.clinicID,
    selectedDate: moment(nextSlotDate),
    activeSlot: slot,
  });

  const [header, setHeader] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isEmpty(slot))
      triggerAppointmentSlotSelect(slot, 'doctor_profile');

    return () => {
      if (isEmpty(slot))
        dispatch(getNextAvailableSlot({
          date: moment().format('YYYY-MM-DD'),
          doctorID: doctor.doctorID,
          clinicID: doctor.clinicID,
        }));
    };
  }, []);

  useEffect(() => {
    if (closingBookingModal)
      onClose({ fetchAppointment: true, isReschedule });
  }, [closingBookingModal]);

  function handleChange({ key, value }: any) {
    switch (key) {
      case 'activeSlot':
        triggerAppointmentSlotSelect(value);
        break;
      default:
        break;
    }

    setState({ ...state, [key]: value });
  }

  function handleBackArrowClick() {
    handleChange({ key: 'activeSlot', value: {} });
  }

  const callback = useCallback((headerNode) => {
    setHeader(headerNode);
  }, []);

  function triggerAppointmentSlotSelect(slot, page_name = 'appointment_schedule') {
    if (!isEmpty(slot))
      cleverTapAnl.event({
        event_name: 'appointment_slot_select',
        event: {
          page_name,
          doctor_id: doctor.doctorID,
          slot_time: slot.parsedStartTime,
          slot_type: slot.teleConsult ? 'video' : 'physical',
          slot_rank: slot.rank,
          appointment_date: moment(state.selectedDate).format('YYYY-MM-DD'),
        },
      } as EventAppointmentSlotSelect);
  }

  function renderContent() {

    if (isEmpty(state.activeSlot))
      return (
        <TimeSlots
          isReschedule={isReschedule}
          doctor={doctor}
          appointment={appointment}
          activeClinicID={state.activeClinicID}
          selectedDate={state.selectedDate}
          parentCallback={callback}
          onChange={handleChange}
        />
      );

    if (state.activeSlot)
      return (
        <ConfirmAppointment
          isReschedule={isReschedule}
          appointment={appointment}
          doctor={doctor}
          activeDate={state.selectedDate}
          activeClinicID={state.activeClinicID}
          slot={state.activeSlot}
          showBackArrow={isEmpty(slot)}
          onBackArrowClick={handleBackArrowClick}
          parentCallback={callback}
        />
      );

    return null;
  }

  return (
    <StyledModal
      isOpen={isOpen}
      hideFooter
      centered
      title={header}
      $maxHeight={
        isMobileOnly ? '95%' : (
          isEmpty(state.activeSlot) ? '80%' : '520px'
        )}
      $maxWidth={isEmpty(state.activeSlot) ? '650px' : '550px'}
      onClose={onClose}
      {...props}
    >
      {renderContent()}
    </StyledModal>
  );
}

export default styled(BookAppointmentModal)``;